module.exports = __webpack_public_path__ + "img/ic_star_border_24px_#B3FF00.2dfe0d41.svg";